import { datadogRum } from '@datadog/browser-rum';

import { beforeSend } from '@consumer-frontend/nc-utils';

if (import.meta.env.VITE_DATADOG_ENABLED === 'true') {
  datadogRum.init({
    applicationId: import.meta.env.VITE_DATADOG_APPLICATION_ID_APPLY,
    beforeSend,
    clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN_APPLY,
    defaultPrivacyLevel: 'mask-user-input',
    env: import.meta.env.VITE_ENV,
    service: 'netcredit-frontend-apply',
    sessionReplaySampleRate: 0,
    sessionSampleRate: 100,
    site: 'datadoghq.com',
    trackLongTasks: true,
    trackResources: true,
    trackUserInteractions: true,
    version: import.meta.env.VITE_GIT_COMMIT,
  });
}
